var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 -10 500 550",
    width: "500px",
    height: "500px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.3,190.8C506.2,187.7 512,190.6 512,195.5L512,400C512,426.5 490.5,448 464,448L48,448C21.5,448 0,426.5 0,400L0,195.6C0,190.6 5.7,187.8 9.7,190.9C32.1,208.3 61.8,230.4 163.8,304.5C184.9,319.9 220.5,352.3 256,352.1C291.7,352.4 328,319.3 348.3,304.5C450.3,230.4 479.9,208.2 502.3,190.8ZM256,320C279.2,320.4 312.6,290.8 329.4,278.6C462.1,182.3 472.2,173.9 502.8,149.9C508.6,145.4 512,138.4 512,131L512,112C512,85.5 490.5,64 464,64L48,64C21.5,64 0,85.5 0,112L0,131C0,138.4 3.4,145.3 9.2,149.9C39.8,173.8 49.9,182.3 182.6,278.6C199.4,290.8 232.8,320.4 256,320Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.61f5ef7c.svg";
export { ForwardRef as ReactComponent };